import { render, staticRenderFns } from "./LvDurationRange.vue?vue&type=template&id=4f22b510"
import script from "./LvDurationRange.vue?vue&type=script&lang=js"
export * from "./LvDurationRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports